import { render, staticRenderFns } from "./AlacakKopyalaForm.vue?vue&type=template&id=5b155dc5"
import script from "./AlacakKopyalaForm.vue?vue&type=script&lang=ts"
export * from "./AlacakKopyalaForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports